export const enum SemboBenefitsType {
  Value = 'Value',
  Trust = 'Trust',
  Simplicity = 'Simplicity',
  Freedom = 'Freedom',
}
